import ContactResponse from './ContactResponse';

export default ContactResponse;
